import React, { useState, useEffect, useCallback } from "react";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import Select from "react-select";
import { Row, Col, Button, Form, Card, Alert, Table } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../env";
import { useAdminAuth } from "../../auth/AdminAuthProvider";
import { FaEye } from "react-icons/fa";
import { FaBan } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { FaArrowRotateLeft } from "react-icons/fa6";
import RetriggerJlgEmiPendingModal from "../components/RetriggerJlgEmiPendingModal";
import RejectReceiptModal from "../components/RejectReceiptModal";
import { MdExpandMore } from "react-icons/md";

const BlEmiPending = () => {
  const { adminUser } = useAdminAuth();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 1000);
  const [emiDate, setEmiDate] = useState(null);
  const [croId, setCroId] = useState(null);
  const [showRetriggerModal, setShowRetriggerModal] = useState(false);
  const [retriggerToRole, setRetriggerToRole] = useState("");
  const [comment, setComment] = useState("");
  const [collectionApprovalId, setCollectionApprovalId] = useState(null);
  const [croOptions, setCroOptions] = useState([]);
  const [selectedCro, setSelectedCro] = useState(null);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [pendingRejectIds, setPendingRejectIds] = useState({ collectionApprovalId: null, receiptId: null });
  const [pendingRetriggerIds, setPendingRetriggerIds] = useState({ collectionApprovalId: null, receiptId: null });

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const fetchCrosData = useCallback(async (managerId) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/getCrosByManagerId`, {
        params: { managerId },
      });
      if (response.data.message) {
        const formattedOptions = response.data.message.map((cro) => ({
          value: cro.id,
          label: cro.username,
        }));
        setCroOptions(formattedOptions);
      } else {
        setCroOptions([]);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchBranchesData = useCallback(async (managerId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/getBranchesByManagerId`,
        {
          params: { managerId },
        }
      );
      if (response.data.message) {
        const formattedOptions = response.data.message.map((branch) => ({
          value: branch.id,
          label: branch.branchName,
        }));
        setBranchOptions(formattedOptions);
      } else {
        setBranchOptions([]);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (adminUser.userType === "Branch Manager") {
      fetchCrosData(adminUser.user.id);
    }
    if (
      adminUser.userType === "MIS" ||
      adminUser.userType === "Accounts Manager"
    ) {
      fetchBranchesData(adminUser.user.id);
    }
  }, [fetchCrosData, adminUser.user.id, adminUser.userType, fetchBranchesData]);

  const handleCroChange = async (selectedOption) => {
    setSelectedCro(selectedOption);
    setTimeout(() => setShowMobileFilters(false), 300);
    if (selectedOption) {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/getBlEmiPendingApprovals`,
          {
            params: { croId: selectedOption.value, role: adminUser.userType },
          }
        );
        if (response.data.message) {
          setPendingApprovals(response.data.message);
        } else {
          setPendingApprovals([]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleBranchChange = async (selectedOption) => {
    setSelectedBranch(selectedOption);
    setTimeout(() => setShowMobileFilters(false), 300);
    if (selectedOption) {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/getBlEmiPendingApprovals`,
          {
            params: {
              role: adminUser.userType,
              branchId: selectedOption.value,
            },
          }
        );
        if (response.data.message) {
          setPendingApprovals(response.data.message);
        } else {
          setPendingApprovals([]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const currentISTDateTime = new Date().toISOString();

  const handleApprove = async (id) => {
    setCollectionApprovalId(id);
    try {
      const payload = {};
      payload.id = id;
      payload.model = "bl_collection_approval";
      payload.type = "Edit";
      if (adminUser.userType === "Branch Manager") {
        payload.branchManagerStatus = "submitted";
        payload.branchManagerStatusUpdatedAt = currentISTDateTime;
      }
      if (adminUser.userType === "MIS") {
        payload.misStatus = "submitted";
        payload.misStatusUpdatedAt = currentISTDateTime;
      }
      if (adminUser.userType === "Accounts Manager") {
        payload.accountManagerStatus = "submitted";
        payload.accountManagerStatusUpdatedAt = currentISTDateTime;
      }
      await axios.post(`${BASE_URL}/api/addDetails`, {
        ...payload,
      });
      if (adminUser.userType === "Branch Manager") {
        fetchCrosData(adminUser.user.id);
        handleCroChange(selectedCro);
      }
      if (
        adminUser.userType === "MIS" ||
        adminUser.userType === "Accounts Manager"
      ) {
        fetchBranchesData(adminUser.user.id);
        handleBranchChange(selectedBranch);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRetrigger = (collectionApprovalId, receiptId) => {
    setPendingRetriggerIds({ collectionApprovalId, receiptId });
    try {
      setShowRetriggerModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleReject = (collectionApprovalId, receiptId) => {
    setPendingRejectIds({ collectionApprovalId, receiptId });
    setShowRejectModal(true);
  };

  const handleRejectConfirm = async (reason) => {
    try {
      // Segregation of duties: MIS may only REQUEST a deletion; the Accounts
      // Manager is the sole authority who can void an entry. The Branch Manager
      // has no deletion rights at all - the button is not rendered for them and
      // the backend rejects the call regardless.
      if (adminUser.userType === "MIS") {
        await axios.post(`${BASE_URL}/api/requestReceiptDeletion`, {
          receiptId: pendingRejectIds.receiptId,
          collectionApprovalId: pendingRejectIds.collectionApprovalId,
          loanType: "BL",
          requestedById: adminUser.user.id,
          requestedByRole: adminUser.userType,
          requestReason: reason,
        });
      } else {
        await axios.put(`${BASE_URL}/api/decideReceiptDeletion`, {
          directDelete: true,
          decision: "approved",
          receiptId: pendingRejectIds.receiptId,
          collectionApprovalId: pendingRejectIds.collectionApprovalId,
          loanType: "BL",
          decidedById: adminUser.user.id,
          decidedByRole: adminUser.userType,
          requestReason: reason,
          decisionReason: reason,
        });
      }
      setShowRejectModal(false);
      setPendingRejectIds({ collectionApprovalId: null, receiptId: null });
      if (adminUser.userType === "Branch Manager") {
        handleCroChange(selectedCro);
      } else {
        handleBranchChange(selectedBranch);
      }
    } catch (error) {
      console.log(error);
      alert("Failed to reject receipt. Please try again.");
    }
  };

  const handleRetriggerConfirm = async () => {
    try {
      await axios.put(`${BASE_URL}/api/retriggerReceipt`, {
        receiptId: pendingRetriggerIds.receiptId,
        collectionApprovalId: pendingRetriggerIds.collectionApprovalId,
        loanType: "BL",
        retriggerToRole,
        triggeredBy: adminUser.userType,
        comment,
        currentISTDateTime,
      });
      if (adminUser.userType === "Branch Manager") {
        fetchCrosData(adminUser.user.id);
        handleCroChange(selectedCro);
      }
      if (
        adminUser.userType === "MIS" ||
        adminUser.userType === "Accounts Manager"
      ) {
        fetchBranchesData(adminUser.user.id);
        handleBranchChange(selectedBranch);
      }
      setShowRetriggerModal(false);
      setComment("");
      setRetriggerToRole("");
      setPendingRetriggerIds({ collectionApprovalId: null, receiptId: null });
    } catch (error) {
      console.log(error);
      alert("Failed to retrigger receipt. Please try again.");
    }
  };

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container">
          <div className="master-search-section">
            <h1 className="TableHeaderText w-100 text-start">BL Emi Pending Approval</h1>

            <button
              className={`filter-toggle-btn ${showMobileFilters ? "active" : ""}`}
              onClick={() => setShowMobileFilters(!showMobileFilters)}
            >
              <span style={{ fontWeight: 600, fontSize: "14px" }}>
                {showMobileFilters ? "Hide Filters" : "Show Filters"}
              </span>
              <MdExpandMore size={22} />
            </button>

            <div className={`w-100 ${!showMobileFilters ? "mobile-hidden" : "mobile-visible"}`}>
              <Row className="w-100" style={{ fontWeight: "500" }}>
                {adminUser.userType === "Branch Manager" && (
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Select CRO</Form.Label>
                      <Select
                        options={croOptions}
                        value={selectedCro}
                        onChange={handleCroChange}
                        placeholder="Select a CRO..."
                        isClearable
                        isSearchable
                        className="cro-select"
                        noOptionsMessage={() => "No CROs available"}
                      />
                    </Form.Group>
                  </Col>
                )}
                {(adminUser.userType === "MIS" ||
                  adminUser.userType === "Accounts Manager") && (
                    <Col md={6} lg={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Select Branch</Form.Label>
                        <Select
                          options={branchOptions}
                          value={selectedBranch}
                          onChange={handleBranchChange}
                          placeholder="Select a Branch..."
                          isClearable
                          isSearchable
                          className="cro-select"
                          noOptionsMessage={() => "No Branches available"}
                        />
                      </Form.Group>
                    </Col>
                  )}
              </Row>
            </div>
          </div>

          <div
            className="master-list-section"
            style={{ padding: "0 20px", overflowY: "auto" }}
          >
            {(selectedCro || selectedBranch) && (
              <div className="p-3">
                <h4 className="mb-4">Pending Approvals</h4>
                {pendingApprovals.length > 0 ? (
                  <div className="master-table-wrapper table-responsive p-0" style={{ padding: "0 15px" }}>
                    <Table striped bordered hover className="table-list mb-0">
                      <thead>
                        <tr>
                          <th>Member Name</th>
                          <th>EMI Date</th>
                          <th>EMI Amount</th>
                          <th>Demand</th>
                          <th>Received Amount</th>
                          <th>Collection Photo</th>
                          <th>Receipt No</th>
                          <th>Remarks</th>
                          {(adminUser.userType === "MIS" ||
                            adminUser.userType === "Accounts Manager") && (
                              <th>Makers Name</th>
                            )}
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingApprovals.map((approval) => (
                          <tr key={approval.id}>
                            <td>
                              {
                                approval
                                  .fk_receipts_belongsTo_member_details_memberId
                                  .memberName
                              }
                            </td>
                            <td>
                              {new Date(
                                approval.emiDate
                              ).toLocaleDateString("en-US")}
                            </td>
                            <td>{approval.emiAmount}</td>
                            <td>{approval.pendingEmiAmount}</td>
                            <td>{approval.receivedAmount}</td>
                            <td>
                              {approval
                                .fk_receipts_hasOne_bl_collection_approval_receiptId
                                .collectionPhoto && (
                                  <a
                                    href={`${BASE_URL}/images/${approval.fk_receipts_hasOne_bl_collection_approval_receiptId.collectionPhoto}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View Photo
                                  </a>
                                )}
                            </td>
                            <td>
                              {
                                approval
                                  .fk_receipts_hasOne_bl_collection_approval_receiptId
                                  .receiptNo
                              }
                            </td>
                            <td>{approval.description}</td>
                            {(adminUser.userType === "MIS" ||
                              adminUser.userType === "Accounts Manager") && (
                                <td>{approval.managerName}</td>
                              )}
                            <td>
                              <div className="d-flex">
                                <Button
                                  variant="success"
                                  onClick={() => {
                                    handleApprove(
                                      approval
                                        .fk_receipts_hasOne_bl_collection_approval_receiptId
                                        .id
                                    );
                                  }}
                                  className="p-1 mx-1"
                                  title="Approve"
                                >
                                  <TiTick size={16} />
                                </Button>
                                <Button
                                  variant="warning"
                                  onClick={() => {
                                    handleRetrigger(
                                      approval
                                        .fk_receipts_hasOne_bl_collection_approval_receiptId
                                        .id,
                                      approval.id
                                    );
                                  }}
                                  className="p-1 mx-1"
                                  title="Retrigger"
                                >
                                  <FaArrowRotateLeft size={17} />
                                </Button>
                                {adminUser.userType !== "Branch Manager" && (
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    handleReject(
                                      approval.fk_receipts_hasOne_bl_collection_approval_receiptId.id,
                                      approval.id
                                    );
                                  }}
                                  className="p-1 mx-1"
                                  title={adminUser.userType === "MIS" ? "Request Deletion" : "Delete Entry"}
                                >
                                  <FaBan size={16} />
                                </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <Alert variant="info" className="m-3">No pending approvals found</Alert>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {showRetriggerModal && (
        <RetriggerJlgEmiPendingModal
          show={showRetriggerModal}
          handleClose={() => setShowRetriggerModal(false)}
          handleConfirm={handleRetriggerConfirm}
          comment={comment}
          setComment={setComment}
          retriggerToRole={retriggerToRole}
          setRetriggerToRole={setRetriggerToRole}
          roleId={adminUser.userType}
        />
      )}
      <RejectReceiptModal
        show={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        onConfirm={handleRejectConfirm}
      />
    </section>
  );
};

export default BlEmiPending;
